<template>
  <div class="col-12">
    <v-form ref="complaintForm">
      <v-row
        v-if="complaintObj.subCategories && complaintObj.subCategories.length >1"
        class="ma-0"
      >
        <v-col
          cols="4"
          class="pb-0 pt-0"
        >
          <naj-input
            v-if="complaintObj.subCategories"
            :type-id="formFieldType.selectbox"
            :value.sync="complaintObj.subCategoryId"
            :value-name.sync="complaintObj.subCategoryName"
            :label="local.complaints.newComplaint.complaintCategoryTab.complaintCategories"
            :items="complaintObj.subCategories"
            :validates="`required`"
            item-value="id"
            item-text="name"
            @change="subCategoryChanged"
          ></naj-input>
        </v-col>
      </v-row>
      <v-row
        v-if="complaintObj.subCategoryId && complaintObj.complaintFormId "
        class="ma-0"
      >
        <v-col cols="12">
          <naj-dynamic-form
            :form-model="complaintObj.complaintForm.formModel"
            :form-fields="complaintForm.fields"
            :custom-component-name="complaintForm.customComponentName"
            :loading="loading"
          ></naj-dynamic-form>
        </v-col>
      </v-row>
    </v-form>
    <div class="button-container">
      <naj-button
        class="left-button"
        @click="cancel()"
      >
        {{ local.common.cancel }}
      </naj-button>
      <div class="right-buttons">
        <naj-button
          type="button"
          color="#89743e"
          icon="mdi-arrow-right"
          @click="previous"
        >
          {{
            local.common.previous
          }}
        </naj-button>
        <naj-button
          type="button"
          append-icon
          icon="mdi-arrow-left"
          :disabled="loading"
          @click="next"
        >
          {{
            local.common.next
          }}
        </naj-button>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { mainComplaintCategories } from '@/modules/complaints/helpers/enum';
const { mapActions: mapComplaintsActions } = createNamespacedHelpers('ComplaintsModule');

export default {
  name: 'ComplaintDetailsTab',
  components: {},
  props: {
    complaintObj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      mainComplaintCategories,
      complaintForm: {},
      loading: false,
    };
  },
  computed: {},
  watch: {
    complaintObj: {
      handler(newVal) {
        if (newVal.reloadForm) {
          this.$set(this.complaintObj, 'reloadForm', false);
          this.getSubCategoriesData(newVal.selectedCategoryId);
        }
      },
      deep: true,
    },
  },
  created() {
  },
  mounted() {
    this.getForm(this.complaintObj.complaintFormId);
    this.getSubCategoriesData(this.complaintObj.selectedCategoryId);
  },
  methods: {
    ...mapComplaintsActions([
      'getComplaintSubCategories',
      'getComplaintForm',
    ]),
    getSubCategoriesData(selectedCategoryId) {
      if (selectedCategoryId) {
        this.getComplaintSubCategories(selectedCategoryId)
          .then(({ data }) => {
            this.complaintObj.subCategories = data;
            if (data && data.length == 1) {
              this.complaintObj.subCategoryId = data[0].id;
              this.complaintObj.subCategoryName = data[0].name;
              this.complaintObj.complaintFormId = data[0].complaintFormId;
              this.getForm(data[0].complaintFormId);
            }
            else {
              this.complaintObj.subCategoryId = null;
              this.complaintObj.subCategoryName = null;
              this.subCategoryDescription = null;
            }
          });
      }
    },
    subCategoryChanged() {
      var selectedSubCategory = this.complaintObj.subCategories.filter(item => item.id == this.complaintObj.subCategoryId)[0];
      if (selectedSubCategory) {
        this.complaintObj.complaintFormId = selectedSubCategory.complaintFormId;
        this.complaintObj.resetFormModel(false);
        this.getForm(selectedSubCategory.complaintFormId);
      }

    },
    getForm(complaintFormId) {
      if (complaintFormId) {
        this.loading = true;
        this.getComplaintForm(complaintFormId)
          .then(({ data }) => {
            this.complaintForm = data;
            this.complaintObj.complaintForm.formFields = data.fields;
            this.complaintObj.complaintForm.customComponentName = data.customComponentName;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    cancel() {
      this.$emit('cancel');
    },
    previous() {
      this.$emit('changeTab', 'tab-2');
    },
    next() {
      this.$refs.complaintForm.$validator.validateAll()
        .then((valid) => {
          if (valid) {

            if (this.complaintObj.selectedCategoryId == mainComplaintCategories.relatedToCase
              && !this.complaintObj.complaintForm.formModel.selectedSession
              && !this.complaintObj.complaintForm.formModel.selectedRequest
              && !this.complaintObj.complaintForm.formModel.selectedJudgement)
              this.toaster.error(this.local.complaints.newComplaint.complaintDetailsTab.notValidForm);
            else {
              this.complaintObj.complaintForm.formModel.viewMode = true;
              this.$emit('changeTab', 'tab-4');
            }

          }
          else
            this.toaster.error(this.local.complaints.newComplaint.complaintDetailsTab.notValidForm);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.tab-header {
  height: 60px;
}
.button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
}
.left-button {
  margin-left: 10px;
}
.right-buttons {
  display: flex;
}

::v-deep {
  .v-data-table__wrapper {
    div {
      text-wrap: pretty;
    }
  }
}
.form-container {
  width: 100%;
}
</style>
